/**
 * Do not edit directly
 * Generated on Tue, 09 Dec 2025 21:27:58 GMT
 */

const theme = {
  colors: {
    border: {
      primary: '#C9CFD4',
      secondary: '#D7DCE0',
      contrast: '#62686E',
      error: '#ba4632',
      caution: '#f3b86b',
      success: '#01845c',
      info: '#C9CFD4',
      highlight: '#156a73',
      input_focus: '#2E67D1',
    },
    blue: {
      '100': '#ECF1FB',
      '200': '#C5D5F2',
      '300': '#A3BDEB',
      '400': '#7DA1E2',
      '500': '#5685DA',
      '600': '#2E67D1',
      '700': '#2D5CB1',
      '800': '#24498C',
      '900': '#172F5B',
    },
    cyan: {
      '100': '#e9f8fa',
      '200': '#9de0e9',
      '300': '#54cddb',
      '400': '#3eb0bd',
      '500': '#479aa4',
      '600': '#117883',
      '700': '#156a73',
      '800': '#15545b',
      '900': '#07363b',
    },
    green: {
      '100': '#edfff6',
      '200': '#baead2',
      '300': '#5ad1a0',
      '400': '#19b682',
      '500': '#019c6d',
      '600': '#01845c',
      '700': '#0a6c4b',
      '800': '#16563d',
      '900': '#133829',
    },
    orange: {
      '100': '#FCF5EF',
      '200': '#FFD4A8',
      '300': '#FFA96E',
      '400': '#FF8A46',
      '500': '#FF7525',
      '600': '#E0621B',
      '700': '#BB4F12',
      '800': '#77320B',
      '900': '#331706',
    },
    pink: {
      '100': '#f7f4f5',
      '200': '#fdd7e8',
      '300': '#faa5ce',
      '400': '#ea8bba',
      '500': '#d582ab',
      '600': '#a46081',
      '700': '#593647',
      '800': '#4b2438',
      '900': '#29111e',
    },
    red: {
      '100': '#ffeae6',
      '200': '#ffc5bb',
      '300': '#ffa293',
      '400': '#f4715f',
      '500': '#e05c44',
      '600': '#ba4632',
      '700': '#a1402f',
      '800': '#7c3324',
      '900': '#51231b',
    },
    yellow: {
      '100': '#fcf6ed',
      '200': '#faeddd',
      '300': '#fcdab1',
      '400': '#f3b86b',
      '500': '#d49234',
      '600': '#ba7c1a',
      '700': '#7f5516',
      '800': '#644418',
      '900': '#412d12',
    },
    neutral: {
      '100': '#F4F5F6',
      '200': '#E6E8EB',
      '300': '#D7DCE0',
      '400': '#C9CFD4',
      '500': '#9EA5AC',
      '600': '#767C82',
      '700': '#62686E',
      '800': '#404347',
      '900': '#1F2124',
      white: '#FFFFFF',
      black: '#000000',
    },
    brand: {
      active_brand: '#F4715F',
      rover: '#00BD70',
      dogbuddy: '#FF5A5B',
      catinaflat: '#F4715F',
      facebook: '#3B5998',
      instagram: '#8A3AB9',
      twitter: '#1DA1F2',
      x: '#000000',
      pinterest: '#C8232C',
      linkedin: '#0A66C2',
      tiktok: '#000000',
      youtube: '#FF0000',
      reddit: '#FF4500',
      google: '#4285F4',
      apple: '#000000',
    },
    interactive: {
      primary_original: '{color.blue.600.value}',
      primary_pressed_original: '{color.blue.700.value}',
    },
    interactive_border: {
      primary_base: '#C9CFD4',
      primary_pressed: '#767C82',
      primary_active: '#593647',
      primary_active_pressed: '#29111e',
      disabled_base: '#E6E8EB',
    },
    interactive_text: {
      primary_base: '#404347',
      primary_active: '#593647',
      disabled_base: '#9EA5AC',
      destructive_base: '#ba4632',
      link_primary_base: '#117883',
      link_primary_pressed: '#15545b',
      link_primary_inverse_base: '#e9f8fa',
      link_primary_inverse_pressed: '#54cddb',
      link_secondary_base: '#593647',
      link_secondary_pressed: '#29111e',
      link_secondary_inverse_base: '#f7f4f5',
      link_secondary_inverse_pressed: '#faa5ce',
    },
    interactive_link: {
      primary_base: '#117883',
      primary_hover: '#15545b',
      primary_visited: '#117883',
      primary_inverse_base: '#e9f8fa',
      primary_inverse_hover: '#54cddb',
      primary_inverse_visited: '#e9f8fa',
      secondary_base: '#593647',
      secondary_hover: '#29111e',
      secondary_visited: '#593647',
      secondary_inverse_base: '#f7f4f5',
      secondary_inverse_hover: '#faa5ce',
      secondary_inverse_visited: '#f7f4f5',
    },
    separator: {
      primary: '#D7DCE0',
    },
    text: {
      primary: '#1F2124',
      primary_inverse: '#FFFFFF',
      secondary: '#404347',
      secondary_inverse: '#F4F5F6',
      tertiary: '#62686E',
      tertiary_inverse: '#E6E8EB',
      placeholder: '#62686E',
      disabled: '#9EA5AC',
      price: '#BB4F12',
      error: '#ba4632',
      caution: '#644418',
      success: '#0a6c4b',
      navigation: '#FFFFFF',
      navigation_hover: '#D7DCE0',
      display: '#f4715f',
    },
  },
  background: {
    primary: '#FFFFFF',
    secondary: '#fcf6ed',
    tertiary: '#faeddd',
    contrast: '#593647',
    accent: '#fcf6ed',
    accent_secondary: '#ECF1FB',
    overlay: 'rgba(31, 33, 36, 0.48)',
    overlay_accent: 'rgba(1, 156, 109, 0.24)',
    error: '#ffeae6',
    caution: '#fcf6ed',
    success: '#edfff6',
    info: '#F4F5F6',
    highlight: '#e9f8fa',
    attention_highlight: '#f3b86b',
    attention_blue: '#C5D5F2',
    navigation: '#593647',
    interactive: {
      primary_base: '#FFFFFF',
      primary_pressed: '#F4F5F6',
      primary_active: '#593647',
      primary_active_pressed: '#29111e',
      button_primary_base: '#593647',
      button_primary_pressed: '#29111e',
      destructive_base: '#ba4632',
      destructive_hover: '#a1402f',
      disabled_base: '#F4F5F6',
    },
  },
  space: {
    '-64x': '-256px',
    '-48x': '-192px',
    '-40x': '-160px',
    '-32x': '-128px',
    '-24x': '-96px',
    '-20x': '-80px',
    '-16x': '-64px',
    '-12x': '-48px',
    '-10x': '-40px',
    '-8x': '-32px',
    '-6x': '-24px',
    '-5x': '-20px',
    '-4x': '-16px',
    '-3x': '-12px',
    '-2x': '-8px',
    '-1x': '-4px',
    '0x': '0px',
    '1x': '4px',
    '2x': '8px',
    '3x': '12px',
    '4x': '16px',
    '5x': '20px',
    '6x': '24px',
    '8x': '32px',
    '10x': '40px',
    '12x': '48px',
    '16x': '64px',
    '20x': '80px',
    '24x': '96px',
    '32x': '128px',
    '40x': '160px',
    '48x': '192px',
    '64x': '256px',
  },
  sizes: {
    '-64x': '-256px',
    '-48x': '-192px',
    '-40x': '-160px',
    '-32x': '-128px',
    '-24x': '-96px',
    '-20x': '-80px',
    '-16x': '-64px',
    '-12x': '-48px',
    '-10x': '-40px',
    '-8x': '-32px',
    '-6x': '-24px',
    '-5x': '-20px',
    '-4x': '-16px',
    '-3x': '-12px',
    '-2x': '-8px',
    '-1x': '-4px',
    '0x': '0px',
    '1x': '4px',
    '2x': '8px',
    '3x': '12px',
    '4x': '16px',
    '5x': '20px',
    '6x': '24px',
    '8x': '32px',
    '10x': '40px',
    '12x': '48px',
    '16x': '64px',
    '20x': '80px',
    '24x': '96px',
    '32x': '128px',
    '40x': '160px',
    '48x': '192px',
    '64x': '256px',
  },
  radii: {
    primary: '8px',
    secondary: '4px',
    round: '99999px',
  },
  borderWidth: {
    primary: '2px',
    secondary: '1px',
  },
  shadows: {
    elevation_high: '0px 8px 10px -6px rgba(27, 31, 35, 0.22)',
    elevation_mid: '0px 2px 12px -1px rgba(27, 31, 35, 0.24)',
    elevation_low: '0px 1px 4px 0px rgba(27, 31, 35, 0.32)',
    border_primary: '0px 0px 0px 2px rgba(207, 215, 222, 1)',
    border_contrast: '0px 0px 0px 2px rgba(102, 114, 124, 1)',
    border_disabled: '0px 0px 0px 2px rgba(232, 235, 237, 1)',
  },
  fontWeight: {
    regular: '400 !important',
    semibold: '700 !important',
  },
  textColor: {
    primary: '#1F2124',
    primary_inverse: '#FFFFFF',
    secondary: '#404347',
    secondary_inverse: '#F4F5F6',
    tertiary: '#62686E',
    tertiary_inverse: '#E6E8EB',
    placeholder: '#62686E',
    disabled: '#9EA5AC',
    price: '#BB4F12',
    error: '#ba4632',
    caution: '#644418',
    success: '#0a6c4b',
    navigation: '#FFFFFF',
    navigation_hover: '#D7DCE0',
    display: '#f4715f',
  },
  textAlign: {
    left: 'left',
    center: 'center',
    right: 'right',
  },
  textDecoration: {
    none: 'none',
    underline: 'underline',
    'line-through': 'line-through',
  },
  textTransform: {
    none: 'none',
    uppercase: 'uppercase',
  },
  variants: {
    card_default: {
      padding: '5x',
      boxShadow: 'elevation_mid',
      borderRadius: 'primary',
    },
    elevation_low: {
      boxShadow: 'elevation_low',
    },
    elevation_mid: {
      boxShadow: 'elevation_mid',
    },
    elevation_high: {
      boxShadow: 'elevation_high',
    },
  },
  buttons: {
    base: {
      borderRadius: 'round',
      cursor: 'pointer',
      bg: 'transparent',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'antialiased',
      '&:hover,&:active': {
        textDecoration: 'none',
      },
    },
    disabled: {
      variant: 'buttons.base',
      color: '#9EA5AC',
      background: 'interactive.disabled_base',
      boxShadow: 'border_disabled',
      cursor: 'not-allowed',
      '&:hover,&:active': {
        color: '#9EA5AC',
      },
    },
    default: {
      base: {
        variant: 'buttons.base',
        color: '#404347',
        background: 'interactive.primary_base',
        boxShadow: '#C9CFD4 0px 0px 0px 2px',
        '&:hover,&:active': {
          color: '#404347',
          background: 'interactive.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'contrast',
        boxShadow: 'border_contrast',
        '&:hover,&:active': {
          color: '#FFFFFF',
          backgroundColor: 'neutral.900',
        },
      },
      destructive: {
        variant: 'buttons.default.base',
        color: '#ba4632',
        '&:hover,&:active': {
          color: '#ba4632',
          background: 'error',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: '#ffeae6',
        boxShadow: 'border_contrast',
        '&:hover,&:active': {
          color: '#f4715f',
          backgroundColor: '#51231b',
        },
      },
    },
    primary: {
      base: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.button_primary_base',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.button_primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.button_primary_base',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.button_primary_pressed',
        },
      },
      destructive: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.destructive_base',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.destructive_hover',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.destructive_base',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.destructive_hover',
        },
      },
    },
    flat: {
      base: {
        variant: 'buttons.base',
        color: 'interactive_text.link_primary_base',
        '&:hover,&:active': {
          color: 'interactive_text.link_primary_pressed',
          background: 'interactive.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: '#404347',
        '&:hover,&:active': {
          color: '#FFFFFF',
          backgroundColor: 'neutral.900',
        },
      },
      destructive: {
        variant: 'buttons.base',
        color: '#ba4632',
        '&:hover,&:active': {
          color: '#a1402f',
          backgroundColor: '#ffeae6',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: '#f4715f',
        '&:hover,&:active': {
          color: '#ffa293',
          backgroundColor: '#51231b',
        },
      },
    },
  },
  text: {
    '50': {
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    '100': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    '200': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    '300': {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: 1.2,
    },
  },
  paragraph: {
    '50': {
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '12px',
    },
    '100': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '12px',
    },
    '200': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '16px',
    },
    '300': {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '24px',
    },
  },
  heading: {
    '50': {
      fontSize: '13px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '8px',
    },
    '100': {
      fontSize: '14px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '8px',
    },
    '200': {
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '12px',
    },
    '300': {
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '16px',
    },
    '400': {
      fontSize: '26px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '20px',
    },
    '500': {
      fontSize: '32px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '24px',
    },
    '600': {
      fontSize: '38px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '32px',
    },
  },
  headingResponsive: {
    '400': {
      fontSize: '32px',
    },
    '500': {
      fontSize: '40px',
    },
    '600': {
      fontSize: '48px',
    },
  },
  display: {
    '400': {
      fontFamily: 'Cat-in-a-Flat-Regular',
      fontSize: '26px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '20px',
    },
    '500': {
      fontFamily: 'Cat-in-a-Flat-Regular',
      fontSize: '32px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '24px',
    },
    '600': {
      fontFamily: 'Cat-in-a-Flat-Regular',
      fontSize: '38px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '32px',
    },
  },
  displayResponsive: {
    '400': {
      fontSize: '32px',
    },
    '500': {
      fontSize: '40px',
    },
    '600': {
      fontSize: '48px',
    },
  },
};

export default theme;

/** The entire theme object. */
export type Theme = typeof theme;

/** Theme color tokens organized by category */
export type Colors = Theme['colors'];
/** Theme background tokens */
export type Background = Theme['background'];
/** Union of all available background color keys from theme */
export type BackgroundColors =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'contrast'
  | 'accent'
  | 'accent_secondary'
  | 'overlay'
  | 'overlay_accent'
  | 'error'
  | 'caution'
  | 'success'
  | 'info'
  | 'highlight'
  | 'attention_highlight'
  | 'attention_blue'
  | 'navigation'
  | 'interactive.primary_base'
  | 'interactive.primary_pressed'
  | 'interactive.primary_active'
  | 'interactive.primary_active_pressed'
  | 'interactive.button_primary_base'
  | 'interactive.button_primary_pressed'
  | 'interactive.destructive_base'
  | 'interactive.destructive_hover'
  | 'interactive.disabled_base';
/** Interactive state background color keys (hover, active, disabled, etc.) */
export type InteractiveBackgroundColors = keyof Theme['background']['interactive'];
/** Theme spacing tokens ('1x', '2x', etc.) */
export type Spacing = keyof Theme['space'];
/** Theme border radius tokens */
export type Radii = keyof Theme['radii'];
/** Theme font weight tokens */
export type FontWeight = keyof Theme['fontWeight'];
/** Theme text alignment values */
export type TextAlign = keyof Theme['textAlign'];
/** Theme text color tokens */
export type TextColor = keyof Theme['textColor'];
/** Theme text decoration values */
export type TextDecoration = keyof Theme['textDecoration'];
/** Theme text transform values */
export type TextTransform = keyof Theme['textTransform'];
export const HEADING_SIZES = ['50', '100', '200', '300', '400', '500', '600'];
/** Theme heading size tokens */
export type HeadingSizes = (typeof HEADING_SIZES)[number];
export const RESPONSIVE_HEADING_SIZES = ['400', '500', '600'];
/** Theme responsive heading size tokens */
export type ResponsiveHeadingSizes = (typeof RESPONSIVE_HEADING_SIZES)[number];
export const DISPLAY_SIZES = ['400', '500', '600'];
/** Theme display size tokens */
export type DisplaySizes = (typeof DISPLAY_SIZES)[number];
export const RESPONSIVE_DISPLAY_SIZES = ['400', '500', '600'];
/** Theme responsive display size tokens */
export type ResponsiveDisplaySizes = (typeof RESPONSIVE_DISPLAY_SIZES)[number];
export const PARAGRAPH_SIZES = ['50', '100', '200', '300'];
/** Theme paragraph size tokens */
export type ParagraphSizes = (typeof PARAGRAPH_SIZES)[number];
export const TEXT_SIZES = ['50', '100', '200', '300'];
/** Theme text size tokens */
export type TextSizes = (typeof TEXT_SIZES)[number];
